import * as React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ProfileContribution } from '../../../store/commonTypes'
import { ContributionType } from '../../../store/contributions/contributionsTypings'

import paths from '../../../paths'
import s from './materialPreview.module.sass'
import { createLocalizedPath } from '../../../utils/localizationHelpers'

interface Props {
    contribution: ProfileContribution | ContributionType
    isAgeVerified: boolean
}

const ContributionItem: React.FunctionComponent<Props> = ({ contribution, isAgeVerified }: Props) => {
    const [t] = useTranslation()

    const handleClick = () => {
        if (contribution.status === 'upload') return createLocalizedPath(paths.submitContribution.path)
        if (contribution.status == 'published') {
            if (contribution.slug)
                return createLocalizedPath(
                    paths.contribution.toPath({ number: contribution.number, title: contribution.slug })
                )
            return createLocalizedPath(paths.contribution.toPath({ number: contribution.number }))
        }
        return createLocalizedPath('/membre')
    }

    return (
        <Link
            className={contribution.status == 'published' ? s['previewContribution'] : s['notPublishedContribution']}
            to={isAgeVerified && handleClick()}
        >
            <div>
                {' '}
                {contribution.status === 'upload' && t('Waiting for uploading')}
                {(contribution.status === 'pending' || contribution.status === 'processed') && t('Pending moderation')}
                {contribution.status === 'rejected' && t('Rejected')}
            </div>
            {contribution.status === 'rejected' ? <p className={s['rejectedText']}>{contribution.note}</p> : <></>}
            {contribution.status === 'published' ? (
                <>
                    <div className={s['contributionPreview_imgWrapper']} tabIndex={-1} data-descr={contribution.title}>
                        <div className={s['contributionPreview_contribution_description']}>
                            <p className={s['contributionPreview_contributionTitle']}>{contribution.title}</p>
                            <span className={s['contributionPreview_contributionDescription']}>
                                {/*@ts-ignore*/}
                                {contribution.description_stripped}
                            </span>
                            <div className={s['contributionPreview_description']}>
                                <span
                                    className={`${s['contributionPreview_gender']} ${
                                        s[`contributionPreview_gender_${contribution.user.gender}`]
                                    }`}
                                >
                                    <p className={s['contributionPreview_nick']}>{contribution.user.nick}</p>
                                </span>
                                <p>
                                    {contribution.user.country && (
                                        <span className={s['contributionPreview_location']}>
                                            {contribution.user.country}
                                            {contribution.user.region && `, ${contribution.user.region}`}
                                        </span>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <img src={contribution.thumbnail} alt={contribution.title} className={s['contributionThumbnail']} />
                </>
            ) : (
                <img src={contribution.thumbnail} alt="" />
            )}
        </Link>
    )
}

export default ContributionItem
